import { render } from "./DetailsAnotherPage.vue?vue&type=template&id=65a14249&scoped=true"
import script from "./DetailsAnotherPage.vue?vue&type=script&lang=js"
export * from "./DetailsAnotherPage.vue?vue&type=script&lang=js"

import "./DetailsAnotherPage.vue?vue&type=style&index=0&id=65a14249&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a14249"],['__file',"src/views/FAQManagement/components/contentComponents/DetailsAnotherPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65a14249"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65a14249', __exports__)) {
    api.reload('65a14249', __exports__)
  }
  
  module.hot.accept("./DetailsAnotherPage.vue?vue&type=template&id=65a14249&scoped=true", () => {
    api.rerender('65a14249', render)
  })

}


export default __exports__